import _Model from "./_Model";
import DeviceAccessory from "./DeviceAccessory";
import CandidateAccessory from "./CandidateAccessory";
import { OPTION_CATEGORIES, candidateAccessoryType, configurationModuleType } from "../constants";
import BOMMap from "./BOMMap";


export default class PowerSupply extends _Model {
  constructor(json) {
    super(json);
    this.id = PowerSupply.getOrDefault(json, 'id', '');
    this.moduleType = configurationModuleType.power_supply;
    this.candidateAccessories = PowerSupply.getMappedOrDefault(json, 'candidateAccessories', [], data => (data || []).map(d => new CandidateAccessory(d)));
    this.accessories = PowerSupply.getMappedOrDefault(json, 'accessories', [], data => (data || []).map(d => new DeviceAccessory(d)));
    this.auxiliaries = PowerSupply.getMappedOrDefault(json, 'auxiliaries', [], data => (data || []).map(d => new DeviceAccessory(d)));
    this.sensors = PowerSupply.getMappedOrDefault(json, 'sensors', [], data => (data || []).map(d => new DeviceAccessory(d)));
    this.spareParts = PowerSupply.getMappedOrDefault(json, 'spareParts', [], data => (data || []).map(d => new DeviceAccessory(d)));
    this.options = PowerSupply.getMappedOrDefault(json, 'options', [], data => (data || []).map(d => new DeviceAccessory(d)));
  }

  allAccessories() {
    return [...this.accessories, ...this.auxiliaries, ...this.sensors, ...this.spareParts, ...this.options];
  }

  accessoriesId() {
    return this.allAccessories().map((acc) => acc.accessory);
  }

  extractReferences() {
    const bomMap = new BOMMap();
    bomMap.addReferencesToBOMMap(this.id, 1);

    if (this.accessories) {
      this.accessories.forEach(accessoryWithQuantity => {
        bomMap.addReferencesToBOMMap(accessoryWithQuantity.accessory, accessoryWithQuantity.quantity);
      });
    }
    if (this.auxiliaries) {
      this.auxiliaries.forEach(accessoryWithQuantity => {
        bomMap.addReferencesToBOMMap(accessoryWithQuantity.accessory, accessoryWithQuantity.quantity);
      });
    }
    if (this.sensors) {
      this.sensors.forEach(accessoryWithQuantity => {
        bomMap.addReferencesToBOMMap(accessoryWithQuantity.accessory, accessoryWithQuantity.quantity);
      });
    }
    if (this.spareParts) {
      this.spareParts.forEach(accessoryWithQuantity => {
        bomMap.addReferencesToBOMMap(accessoryWithQuantity.accessory, accessoryWithQuantity.quantity);
      });
    }
    if (this.options) {
      this.options.forEach(accessoryWithQuantity => {
        bomMap.addReferencesToBOMMap(accessoryWithQuantity.accessory, accessoryWithQuantity.quantity);

        if (accessoryWithQuantity.subAccessories) {
          accessoryWithQuantity.subAccessories.forEach(subAccessory => {
            bomMap.addReferencesToBOMMap(subAccessory.accessory, subAccessory.quantity);
          });
        }
      });
    }

    return bomMap;
  }

  recommandedAccessories() {
    const accessories = [];
    this.candidateAccessories.forEach((accessory) => {
      if (candidateAccessoryType.recommanded === accessory.type) {
        accessories.push(accessory.id);
      }
    });

    return accessories;
  }

  mandatoryAccessories() {
    const accessories = [];
    this.candidateAccessories.forEach((accessory) => {
      if (candidateAccessoryType.mandatory === accessory.type) {
        accessories.push(accessory.id);
      }
    });
    return accessories;
  }

  extractOptionsWithQuantity () {
    const result = {};
    const addToResult = (type, accessoryId, quantity) => {
      if (result[type] == null) {
        result[type] = {};
      }
      if (result[type][accessoryId] == null) {
        result[type][accessoryId] = 0;
      }
      result[type][accessoryId] += quantity;
    };

    this.accessories.forEach(a => {
      addToResult(OPTION_CATEGORIES.ACCESSORIES, a.accessory, a.quantity);
    });
    this.auxiliaries.forEach(a => {
      addToResult(OPTION_CATEGORIES.AUXILIARIES, a.accessory, a.quantity);
    });
    this.sensors.forEach(s => {
      addToResult(OPTION_CATEGORIES.SENSORS, s.accessory, s.quantity);
    });
    this.spareParts.forEach(s => {
      addToResult(OPTION_CATEGORIES.SPARE_PARTS, s.accessory, s.quantity);
    });
    this.options.forEach(o => {
      addToResult(OPTION_CATEGORIES.OPTIONS, o.accessory, o.quantity);
    });
    return result;
  }

  extractSelectedOptions () {
    const result = {
      accessories: [],
      services: []
    };
    this.accessories.forEach(a => {
      result.accessories.push({
        id: a.accessory,
        quantity: a.quantity,
        accessoryType: OPTION_CATEGORIES.ACCESSORIES,
        subAccessories: a.extractSelectedSubAccessories()
      });
    });
    this.auxiliaries.forEach(a => {
      result.accessories.push({
        id: a.accessory,
        quantity: a.quantity,
        accessoryType: OPTION_CATEGORIES.AUXILIARIES,
        subAccessories: a.extractSelectedSubAccessories()
      });
    });
    this.sensors.forEach(s => {
      result.accessories.push({
        id: s.accessory,
        quantity: s.quantity,
        accessoryType: OPTION_CATEGORIES.SENSORS,
        subAccessories: s.extractSelectedSubAccessories()
      });
    });
    this.spareParts.forEach(s => {
      result.services.push({
        id: s.accessory,
        quantity: s.quantity,
        accessoryType: OPTION_CATEGORIES.SPARE_PARTS,
        subAccessories: s.extractSelectedSubAccessories()
      });
    });
    this.options.forEach(o => {
      result.accessories.push({
        id: o.accessory,
        type: o.type,
        quantity: o.quantity,
        accessoryType: OPTION_CATEGORIES.OPTIONS,
        subAccessories: o.extractSelectedSubAccessories()
      });
    });

    return result;
  }

  extractSelectedSubAccessoryQuantityForAccessory = (accessoryId, subAccessoryId) => {
    let result = 0;
    const accessoriesAdded = [...this.accessories, ...this.auxiliaries, ...this.sensors, ...this.spareParts, ...this.options];
    accessoriesAdded.forEach(accessory => {
      if (accessory.accessory === accessoryId) {
        (accessory.subAccessories || []).forEach(subAccessory => {
          if (subAccessory.accessory === subAccessoryId) {
            result += subAccessory.quantity;
          }
        });
      }
    });
    return result;
  }
}
